if not App.angularApp?
    return

App.angularApp.directive 'mfValidateSave', ['$compile', ($compile) ->
    return {
        restrict: 'A'
        require: ['^mfValidate']
        scope:
            mfValidateSave: '='
            alwaysReenable: '='
        link: ($scope, element, attrs, ctrl) ->
            mfValidate = ctrl[0]
            params = [].concat $scope.mfValidateSave
            element.on 'click', () ->

                # disable this input
                element.prop('disabled', true)

                # If a valid promise was returned handle it
                mfValidate.save(true, params)?.then? (result) ->
                    # re-enable if the request succeeded but returned an error,
                    # e.g. if backend validation failed.
                    if $scope.alwaysReenable or not result? or result?.data?.status?.type is 'error'
                        element.prop 'disabled', false
                , () ->
                    # re-enable if the request failed
                    element.prop 'disabled', false
    }
]
